/* eslint-disable */
import {
  DEALER_QUERY_REQUEST,
  DEALER_SET_ZIP_CODE,
  DEALER_OBJECT_UPDATE,
  DEALER_QUERY_SUBMITTING,
  DEALER_QUERY_SUCCESS,
  DEALER_QUERY_ERROR,
  DEALER_OBJECT_RESET,
  DEALER_CLEAR_ERROR,
  DEALER_RESET_STATE
} from '../constants';

const initialState = {
  dealersObject: null,
  currentZipCode: '',
  querySucceeded: false,
  querying: false,
  response: null,
  query: null,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DEALER_QUERY_SUBMITTING:
      return {
        ...state,
        querySucceeded: false,
        querying: true,
        response: null,
        query: action.query,
        queryFailed: false,
        error: null
      };

    case DEALER_QUERY_SUCCESS:
      return {
        ...state,
        querySucceeded: true,
        querying: false,
        response: action.response,
        dealersObject: action.dealersObject,
        queryFailed: false,
        error: null
      };

    case DEALER_QUERY_ERROR:
      return {
        ...state,
        dealersObject: null,
        querying: false,
        response: null,
        queryFailed: true,
        error: action.error
      };

    case DEALER_OBJECT_RESET:
      return {
        ...state,
        dealersObject: null
      };

    case DEALER_CLEAR_ERROR:
      return {
        ...state,
        queryFailed: false,
        error: null
      };

    case DEALER_OBJECT_UPDATE:
      return {
        ...state,
        dealersObject: action.dealersObject
      };

    case DEALER_SET_ZIP_CODE:
      return {
        ...state,
        currentZipCode: action.zipCode
      };

    case DEALER_RESET_STATE:
      return {
        ...initialState
      };

    default:
      return state;
  }
}

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/dealer.js
 **/